import { Button, Icon, Tooltip, useTooltipText } from "@saviynt/design-system";
import PropTypes from "prop-types";

/**
 * To render copy button with tooltip functionality
 * When user clicks on copy button
 * value gets copied button colour will change to green
 * after 5 second, It will come to default state
 */

function CopyButton({
  handleCopyOnClick,
  isCopyButtonClicked,
  copyButtonKey,
  copyButtonValue,
}) {
  const {
    tooltipText,
    isDisabled,
    handleTooltipTriggerClick,
    handleTooltipClose,
    tooltipCloseDelayAfterClick,
  } = useTooltipText({
    initialText: "Copy",
    updatedText: "Copied",
    closeDelayAfterClick: 5000,
  });
  const isCopyButtonClickedWithDisable = !isDisabled && isCopyButtonClicked;

  const handleOnClick = () => {
    handleCopyOnClick(copyButtonValue);
    handleTooltipTriggerClick();
  };

  return (
    tooltipText && (
      <Tooltip
        text={tooltipText}
        placement="top"
        closeDelayAfterClick={tooltipCloseDelayAfterClick}
        onClose={handleTooltipClose}
        isDisabled={isCopyButtonClickedWithDisable}
        trigger={
          <Button
            type="button"
            kind="outlined"
            size="large"
            isSuccess={isCopyButtonClickedWithDisable}
            leftIcon={
              <Icon
                kind={isCopyButtonClickedWithDisable ? "check" : "Copy"}
                size="medium"
                color="neutral-100"
              />
            }
            onClick={handleOnClick}
            dataTestId={`copy-button-${copyButtonKey}`}
          />
        }
      />
    )
  );
}

CopyButton.propTypes = {
  handleCopyOnClick: PropTypes.func,
  isCopyButtonClicked: PropTypes.bool,
  copyButtonKey: PropTypes.string,
  copyButtonValue: PropTypes.string,
};

CopyButton.defaultProps = {
  handleCopyOnClick: null,
  isCopyButtonClicked: null,
  copyButtonKey: null,
  copyButtonValue: null,
};

export default CopyButton;
